import * as Constants from '../constants';
import lodashGet from 'lodash/get';

const initialState = {
  searchResults: {},
  searchQuery: '',
  searchResultsDiagnostics: [],
  error: {},
  isSearching: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.PRODUCT_SEARCH_START:
      return Object.assign({}, state, { searchResults: {}, isSearching: true });
    case Constants.PRODUCT_SEARCH_SUCCESS:
      const omsEnabled = action.queryParams.omsEnabled;
      const customMedicine = {
        id: -1,
        productId: -1,
        flagId: 0,
        name: action.queryParams.q,
        availabilityLevel: 2,
        manufacturer: '-',
        salePrice: 0,
        measurementUnit: '-',
        canBeSold: true,
        productType: 1,
        searchQuery: '',
        maxQuantity: 20,
      };
      const results = lodashGet(action.data, 'data.products', []);
      const isMatched = results.find(item => item.name === action.queryParams.q);
      if (!isMatched && !omsEnabled) {
        action.queryParams.q && results.push(customMedicine);
      }
      return Object.assign({}, state, { searchResults: action.data, isSearching: false });
    case Constants.PRODUCT_SEARCH_FALIURE:
      return Object.assign({}, state, {...action.data, isSearching: false});
    case Constants.PRODUCT_SEARCH_CLEAR:
      return Object.assign({}, state, { searchResults: {}, isSearching: false });
    case Constants.PRODUCT_SEARCH_DIAG_CLEAR:
      return Object.assign({}, state, { searchResultsDiagnostics: [] });
    case Constants.PRODUCT_SEARCH_DIAG_START:
      return Object.assign({}, state, { searchResultsDiagnostics: state.searchResultsDiagnostics });
    case Constants.PRODUCT_SEARCH_DIAG_SUCCESS:
      return Object.assign({}, state, { searchResultsDiagnostics: [...state.searchResultsDiagnostics, ...action.data.data.search_data], searchQuery: action.queryParams.q });
    case Constants.PRODUCT_SEARCH_DIAG_FAILURE:
      return Object.assign({}, state, { error: action.data.error, searchResultsDiagnostics: [], searchQuery: '' });
    default:
      return { ...state };
  }
}
